import React from "react";
import Layout from "../components/layouts/Layout";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <Layout title={"About Us - UrbanCart"}>
      <div className="container-fluid p-5 bg-light text-dark">
        <div className="text-center mb-5">
          <h1>About UrbanCart</h1>
          <p>Your trusted partner in online shopping</p>
        </div>

        <div className="row justify-content-center mb-5">
          <div className="col-md-8">
            <h3 className="mb-4">Our Journey</h3>
            <p>
              Founded in 2024, UrbanCart started with a mission to revolutionize the online shopping experience. With a focus on quality, variety, and customer satisfaction, we have grown into a trusted e-commerce platform serving thousands of happy customers.
            </p>
            <p>
              We believe in empowering shoppers with choices and delivering products that meet their needs and desires. Our journey has been one of innovation, passion, and dedication, with a commitment to excellence in everything we do.
            </p>
          </div>
        </div>

        <div className="row text-center mb-5">
          <h3 className="mb-4">What We Stand For</h3>
          <div className="col-md-4">
            <div className="card p-4 shadow-sm border-0 mb-4">
              <h4 className="card-title">Customer First</h4>
              <p className="card-text">
                Our customers are at the heart of everything we do. We strive to provide an exceptional shopping experience and build long-lasting relationships.
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card p-4 shadow-sm border-0 mb-4">
              <h4 className="card-title">Innovation</h4>
              <p className="card-text">
                We constantly innovate to bring the best products and services to our customers. Staying ahead of trends allows us to offer the latest and greatest.
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card p-4 shadow-sm border-0 mb-4">
              <h4 className="card-title">Sustainability</h4>
              <p className="card-text">
                We are committed to sustainability and ethical practices. Our goal is to reduce our environmental impact and promote responsible sourcing.
              </p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center mb-5">
          <div className="col-md-8">
            <h3 className="mb-4">Our Vision</h3>
            <p>
              To be the most customer-centric online shopping destination, where people can discover and purchase a wide range of products with ease and confidence.
            </p>
          </div>
        </div>

        <div className="row justify-content-center mb-5">
          <div className="col-md-8">
            <h3 className="mb-4">Meet Our Team</h3>
            <p>
              Our team is a diverse group of talented individuals who share a passion for e-commerce and customer satisfaction. Together, we work tirelessly to bring the best shopping experience to our customers.
            </p>
          </div>
        </div>

        <div className="row text-center">
          <div className="col-md-12">
            <h3>Get in Touch</h3>
            <p>
              Have questions? We're here to help! Reach out to our customer support team, and we'll get back to you as soon as possible.
            </p>
          </div>
        </div>

        <div className="row mt-5 text-center">
          <div className="col-md-12">
            <h2 className="section-title">Ready to Shop?</h2>
            <p>Join thousands of happy customers and experience the UrbanCart difference.</p>
            <Link to="/" className="btn btn-primary">Start Shopping</Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default About;
